import { connect } from "react-redux"
import { h, Fragment } from "preact"
import { isMobileAgent } from "../_common/common"
import { t } from '../_i18n'

import './trial-cintillo.scss'

const TrialCintillo = ({ studentMeta, helpModeStep }) => {
    /** Variables **/
    const start = new Date(studentMeta.trial_start_date)
    const today = new Date()
    today.setHours(0, 0, 0, 0)
    start.setHours(0, 0, 0, 0)
    const timeDifference = today - start
    const daysDifference = Math.max(Math.floor(timeDifference / (1000 * 60 * 60 * 24)), 0)
    const expirationMessage = t("trial_expiration").replace('{DAYS}', 15 - daysDifference)

    /** Return **/
    return (
        <Fragment>
            <div className={`trial-banner txt-color-white background-danger d-flex flex-center-x flex-center-y
                ${helpModeStep && 'z-100'}
            `}>
                <Fragment>
                    <span className={isMobileAgent() && 'trial-banner__header--mobile'}>{expirationMessage}</span>
                </Fragment>
            </div>
        </Fragment>
    )
}

/** Redux Container **/
const TrialCintilloContainer = connect(
    ({  status, general }) => ({
        studentMeta: status.student_meta,
        helpModeStep: general.helpModeStep
    }),
    {}
)(TrialCintillo)

/** Export **/
export default TrialCintilloContainer
